module.exports = __webpack_public_path__ + "img/android.924f0288.png";